import React from 'react';
import ReCAPTCHA from "react-google-recaptcha";
import Container from '@material-ui/core/Container';
import Avatar from '@material-ui/core/Avatar';
import RestoreOutlinedIcon from '@material-ui/icons/RestoreOutlined';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import {post} from './procedures';
import {googleSiteKey} from './procedures';

class Restore extends React.Component  {
    constructor(props) {
        super(props);

        this.state = {httpd_username: ''};

        this.state = {recaptchaRef: React.createRef()};
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleRestore = this.handleRestore.bind(this);
        this.emailChange = this.emailChange.bind(this);
    }

    handleSubmit(event) {
        this.state.recaptchaRef.current.execute();
    }

    handleRestore() {
        const recaptchaValue = this.state.recaptchaRef.current.getValue();

        var obj_tosend={};
        obj_tosend.action = 'restore';
        obj_tosend.g_recaptcha_response = recaptchaValue;
        obj_tosend.httpd_username = this.state.httpd_username;

        post('./tokensignin.php', obj_tosend);
        //post('http://192.168.1.43/login_to_console/tokensignin.php', obj_tosend);
    }

    emailChange(event) {
        this.setState({httpd_username: event.target.value})
    }

    render() {

        return (

            <Container component="main" maxWidth="xs">
                <div className={this.props.classes.paper}>
                    <Avatar className={this.props.classes.avatar}>
                        <RestoreOutlinedIcon/>
                    </Avatar>
                    <Typography component="h1" variant="h5">
                        Восстановление пароля
                    </Typography>
                    <form className={this.props.classes.form} noValidate>
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            id="email"
                            label="Email"
                            name="email"
                            autoComplete="email"
                            autoFocus
                            onChange={this.emailChange}
                        />
                        <Grid container alignItems="center" className={this.props.classes.submitgrid}>
                            <Grid item xs>
                                <Button
                                      fullWidth
                                      size="large"
                                      variant="contained"
                                      color="primary"
                                      className={this.props.classes.submit}
                                      onClick={this.handleSubmit}
                                >
                                    Получить инструкции по email
                                </Button>
                            </Grid>
                        </Grid>
                        <br />
                        <div className={this.props.classes.linkCenter}>
                                <Link href="./" variant="body2">
                                    Вход в портал
                                </Link>
                        </div>

                        <ReCAPTCHA ref={this.state.recaptchaRef}
                                   sitekey={googleSiteKey}
                                   size="invisible"
                                   onChange = {this.handleRestore}
                        />
                    </form>
                </div>
            </Container>

        )

    }

}

export default Restore;